import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { SectionContainer } from "../../../Utils/SectionContainer";
import { defaultStyles } from "./defaultStyles";

export interface HeroBlock6Props extends ComponentPropsWithRef<"table"> {
  headerContent?: ReactNode;
  imageContent?: ReactNode;
  primaryButton?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HeroBlock6 = forwardRef<HTMLTableElement, HeroBlock6Props>(
  (
    { headerContent, primaryButton, styles = {}, imageContent, ...rest },
    ref,
  ) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
      },
    );

    return (
      <SectionContainer cssProperties={marginStyles}>
        <Section
          ref={ref}
          style={{
            ...backgroundStyles,
            ...paddingStyles,
          }}
          {...rest}
        >
          <Row>{imageContent}</Row>
          <Row>
            <Column
              style={{
                paddingTop: "48px",
              }}
            >
              <Row>
                <Column>{headerContent}</Column>
              </Row>

              <Row>
                <Column>
                  <BlockSection.NestedBlock>
                    {primaryButton}
                  </BlockSection.NestedBlock>
                </Column>
              </Row>
            </Column>
          </Row>
        </Section>
      </SectionContainer>
    );
  },
);

HeroBlock6.displayName = "HeroBlock6";
